import React, { forwardRef } from "react";
import { StyledSaveDraftButton } from "./SaveDraftButton.styles";
import type { SaveDraftButtonProps } from "./SaveDraftButton.types";

export const SaveDraftButton = forwardRef<
  HTMLButtonElement,
  SaveDraftButtonProps
>(
  (
    {
      variant = "secondary",
      size = "md",
      type = "button",
      headerMinWidth = false,
      ...props
    },
    ref,
  ) => (
    <StyledSaveDraftButton
      ref={ref}
      variant={variant}
      size={size}
      type={type}
      $headerMinWidth={headerMinWidth}
      {...props}
    />
  ),
);

SaveDraftButton.displayName = "SaveDraftButton";

export default SaveDraftButton;
